var config = {
    apiUrl: "https://or-dcmobileapp.pttor.com/",
    apiKey: "1I8icT8c0_wMLu28iwSoCcgwg5AAkW1JrTqp6pNvtlA"
}

export default config